export const ViewParams =  {
    Entity: 'Entity',
    Me: 'Me',
    CurrentDateTime: 'CurrentDateTime'
};
